export enum CaseStatus {
  PLANNED = 'PLANNED',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  PROGRESS = 'PROGRESS',
  DELETED = 'DELETED',
  FAULT = 'FAULT',
  FAULT_RETRY = 'FAULT_RETRY',
  //ERROR is the final Status
  FAULT_CONFIRMED = 'FAULT_CONFIRMED',
  ABORTED = 'ABORTED',
  SUCCESS = 'SUCCESS',
  FAULT_RETRY_CONFIRMED = 'FAULT_RETRY_CONFIRMED',
  CHECKING_PRECONDITIONS = 'CHECKING_PRECONDITIONS',
  SUCCESS_WITH_WARNING = 'SUCCESS_WITH_WARNING'
}

export const PRE_EXECUTION_CASE_STATUSES: ReadonlySet<CaseStatus> = new Set([
  CaseStatus.PLANNED,
  CaseStatus.CHECKING_PRECONDITIONS,
  CaseStatus.PROGRESS,
]);
